import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AddNewGroupComponent } from "../../add-new-group/add-new-group.component";
import { NavBarComponent } from "../../../nav-bar/nav-bar.component";
import { SampleService } from "../../../services/sample.service";
import { catchError, takeUntil } from "rxjs/operators";
import { ReplaySubject, Subject, throwError } from "rxjs";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { GroupService } from 'src/app/services/group.service';
import { SampleGroupModel } from 'src/app/models/sample-group-model';
import { HelperService } from 'src/app/helper.service';
import { PinDetailsService } from 'src/app/pin-reworks/pin-services/pin-details.service';
import { is } from 'node_modules/cypress/types/bluebird';


@Component({
    selector: 'app-add-edit-sample',
    templateUrl: './add-edit-soil-sample.component.html',
    styleUrls: ['./add-edit-soil-sample.component.css'],
    standalone: false
})
export class AddEditSoilSampleComponent implements OnInit, OnDestroy {
  soilSampleForm: FormGroup;
  groups = [];
  group: SampleGroupModel = null;
  userId = this.data.userId;
  tenantId = this.data.tenantId;
  pinId: number = this.data.pinId;
  sampleId: number = this.data.sampleId;

  isEditSampleMode: boolean = false;
  isAddNewSapleMode: boolean = false;

  moveToGroupId: number = 0;
  selectedToMove = null;
  isCompleted: boolean = false;
  definitions: any[] = [];
  selectedDefinitionId: number = null;
  isOrphanedLink: boolean = false;

  /** control for the selected group */
  // public groupCtrl: FormControl<SampleGroupModel> = new FormControl<SampleGroupModel>(null);

  /** control for the MatSelect filter keyword */
  public groupFilterCtrl: FormControl<string> = new FormControl<string>('');

  /** list of group  filtered by search keyword */
  public filteredSampleGroups: ReplaySubject<SampleGroupModel[]> = new ReplaySubject<SampleGroupModel[]>(1);

  /** Subject that emits when the component has been destroyed. */
  protected _onGroupDestroy = new Subject<void>();


  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private newSampleFb: FormBuilder,
    public soilSampleDialog: MatDialogRef<AddEditSoilSampleComponent>,
    public addGroupDialog: MatDialog,
    private sampleService: SampleService,
    private groupService: GroupService,
    public nav: NavBarComponent,
    public moveToDialog: MatDialog,
    public helper: HelperService,
    private pinDetailsService: PinDetailsService
  ) {
    this.soilSampleForm = this.newSampleFb.group({
      sampleName: ['', Validators.required],
      sampleDepth: new FormControl(null),
      rockPercentage: new FormControl(null),
      note: new FormControl(''),
      pinSampleGroup: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this.nav.toggleLoading(true);
    this.populateGroupDropdown(this.data?.linkedGroup);
    this.setPreviousSelection();
    this.loadDefinitions();

    if (this.data !== null) {
      this.isEditSampleMode = this.data.isEditSampleMode;
      this.isAddNewSapleMode = this.data.isAddNewSapleMode;
    }

    if (this.isAddNewSapleMode && this.data?.isGrid && this.data?.gridSampleName) {
      this.soilSampleForm.controls.sampleName.setValue(this.data.gridSampleName);
    }

    if (this.data && this.isEditSampleMode) {
      setTimeout(() => {
        this.isCompleted = this.data?.isCompleted;
        this.soilSampleForm.controls.sampleName.setValue(this.data.sampleName);
        this.soilSampleForm.controls.sampleDepth.setValue(this.data.sampleDepth);
        this.soilSampleForm.controls.rockPercentage.setValue(this.data.rockPercentage);
        this.soilSampleForm.controls.note.setValue(this.data.note);

        if (this.data?.linkedGroup) {
          for (let group of this.groups) {
            if (group?.id === this.data?.linkedGroup) {
              this.group = group;
              break;
            }
          }
        }
        this.soilSampleForm.controls.pinSampleGroup.setValue(this.group);
        this.nav.toggleLoading(false);
      }, 1000)
    }
  }

  /**
* Method that sets the intial group list that will be displayed in the group dropdown.
*/
  setInitialGroupList() {
    // Load the initial group list
    this.filteredSampleGroups.next(this.groups.slice());
    // Listen for search field value changes
    this.groupFilterCtrl.valueChanges
      .pipe(takeUntil(this._onGroupDestroy))
      .subscribe(() => {
        this.filterGroups();
      });
  }


  protected filterGroups() {
    if (!this.groups) {
      return;
    }
    // Get the search keyword
    let search = this.groupFilterCtrl.value;
    if (!search) {
      this.filteredSampleGroups.next(this.groups.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    // Filter the group based on the search keyword
    this.filteredSampleGroups.next(
      this.groups.filter(group => group.name.toLowerCase().indexOf(search) > -1)
    );
  }


  addNewGroup() {
    const dialogRef = this.addGroupDialog.open(AddNewGroupComponent, {
      data: {
        userId: this.userId,
        tenantId: this.tenantId,
      },
      width: '420px'
    });

    dialogRef.afterClosed().subscribe(groupId => {
      if(groupId) {
        this.populateGroupDropdown(groupId);
      }
    });
  }

  populateGroupDropdown(groupId?: number) {
    this.groupService.getGroups(this.data.tenantId).pipe(
      catchError(error => {
        console.error();
        return throwError(() => error);
      })
    ).subscribe((result) => {
      this.groups = result;
      if(this.groups.length > 0) {
        console.log(this.groups)
        console.log(this.data)
        this.groups = this.groups.filter(g => !g.isGrid || this.data?.isGrid || (this.isEditSampleMode && this.data?.linkedGroup === g.id));
      }
      
      if(groupId) {
        let group = this.groups.find(g => g.id === groupId);
        this.soilSampleForm.controls.pinSampleGroup.setValue(group);
      }
      
      this.setInitialGroupList();
    })
  }


  saveSample() {
    this.nav.toggleLoading(true);

    let sampleObj = {
      pinId: this.pinId,
      linkedGroup: this.soilSampleForm.get('pinSampleGroup').value?.id,
      name: this.soilSampleForm.get('sampleName').value,
      sampleDepth: this.soilSampleForm.get('sampleDepth').value,
      rockPercentage: this.soilSampleForm.get('rockPercentage').value,
      note: this.soilSampleForm.get('note').value
    };

    this.pinDetailsService.setSoilSampleDetails(sampleObj);

    this.sampleService.postSoilSample(sampleObj?.pinId, sampleObj?.linkedGroup, sampleObj?.name, sampleObj?.sampleDepth, sampleObj?.rockPercentage, sampleObj?.note, this.selectedDefinitionId).pipe(
      catchError(error => {
        console.error(error);
        this.nav.toggleLoading(false);
        return throwError(() => error);
      })
    ).subscribe(() => {
      this.soilSampleDialog.close();
    });
  }

  deleteSample() {

    this.nav.toggleLoading(true);

    this.sampleService.deleteSampleById(this.sampleId).pipe(
      catchError(error => {
        console.error(error);
        this.nav.toggleLoading(false);
        return throwError(() => error);
      })
    ).subscribe(() => {
      this.soilSampleDialog.close();
      this.nav.toggleLoading(false);
    });
  }

  updateSample() {
    this.nav.toggleLoading(true);

      let sampleObj = {
        pinId: this.pinId,
        sampleId: this.sampleId,
        linkedGroup: this.moveToGroupId ? this.moveToGroupId : this.soilSampleForm.get('pinSampleGroup').value?.id,
        name: this.soilSampleForm.get('sampleName').value,
        sampleDepth: this.soilSampleForm.get('sampleDepth').value,
        rockPercentage: this.soilSampleForm.get('rockPercentage').value,
        note: this.soilSampleForm.get('note').value,
        is_completed: this.isCompleted
      };
      this.sampleService.updateSoilSample(sampleObj?.pinId, sampleObj?.sampleId, sampleObj?.linkedGroup, sampleObj?.name, sampleObj?.sampleDepth, sampleObj?.rockPercentage, sampleObj?.note, sampleObj?.is_completed).pipe(
        catchError(error => {
          console.error(error);
          this.nav.toggleLoading(false);
          return throwError(() => error);
        })
      ).subscribe(() => {
        if (this.selectedDefinitionId) {
          this.sampleService.updateSampleLink(this.sampleId, this.selectedDefinitionId).subscribe(() => {
            this.soilSampleDialog.close();
          });
        } else {
          this.soilSampleDialog.close();
        }
      });
  }


  updateSampleGroup(group: SampleGroupModel) {
    if (this.group?.id !== group?.id) {
      this.moveToGroupId = group?.id;
    }
  }

  cancel() {
    this.soilSampleDialog.close();
  }


  setPreviousSelection(){

    if(this.pinDetailsService.getSoilSampleDetails() && !this.isEditSampleMode){
    
        let previousSelectedSoilDetail = this.pinDetailsService.getSoilSampleDetails();

        // Name not restored for grid samples - they get auto-generated names
        if (!this.data?.isGrid) {
          this.soilSampleForm.controls.sampleName.setValue(previousSelectedSoilDetail?.name);
        }
        this.soilSampleForm.controls.sampleDepth.setValue(previousSelectedSoilDetail?.sampleDepth);
        this.soilSampleForm.controls.rockPercentage.setValue(previousSelectedSoilDetail?.rockPercentage);
        this.soilSampleForm.controls.note.setValue(previousSelectedSoilDetail?.note);
  
        setTimeout(() => {

        if (previousSelectedSoilDetail?.linkedGroup && !this.data?.isGrid) {
          for (let group of this.groups) {
            if (group?.id === previousSelectedSoilDetail?.linkedGroup) {
              this.group = group;
              break;
            }
          }
        }
        if (this.group) {
          this.soilSampleForm.controls.pinSampleGroup.setValue(this.group);
        }
        this.nav.toggleLoading(false);
        },1000)
        } else {
          this.nav.toggleLoading(false);
        }
      }


  loadDefinitions() {
    this.sampleService.getDefinitionsForPin(this.pinId).subscribe((defs) => {
      this.definitions = defs || [];
      if (this.data?.seasonFieldDetailId) {
        this.selectedDefinitionId = this.data.seasonFieldDetailId;
        this.isOrphanedLink = !this.definitions.some(d => d.id === this.selectedDefinitionId);
      } else if (this.definitions.length === 1) {
        this.selectedDefinitionId = this.definitions[0].id;
      }
    });
  }

  ngOnDestroy() {
    this._onGroupDestroy.next();
    this._onGroupDestroy.complete();
  }
}
